module.exports = __webpack_public_path__ + "assets/img/ed10202eefe7ac5bb7d3ffa7f4eabf7d.svg";